import Api from "@/api/index";
import loading from "./loading";
import confirmations from "./confirmations";
import alerts from "@/alerts/alert";
import AuthenticationService from "@/services/AuthenticationService";
import store from "@/store";
// import alerts from "@/components/alerts/alert";
// import router from "@/router";

const rekening = {
  namespaced: true,
  state: {
    all: [],
    datas: {},
    form: {},
    queryParam: {},
    loading: false,
    modalCreate: false,
    detail: {},
    action: "",
  },
  getters: {
    getDatas(state) {
      return state.datas;
    },
  },
  mutations: {
    SET_DATAS(state, datas) {
      state.datas = datas;
    },
    SET_ALL(state, datas) {
      state.all = datas;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_QUERY_PARAM(state, data) {
      state.queryParam = data;
    },
    SET_MODAL_CREATE(state, data) {
      state.modalCreate = data;
    },
  },
  actions: {
    async paginate({ commit }, payload) {
      commit("SET_LOADING", true);
      commit("SET_QUERY_PARAM", payload);
      return await Api.doPaginate("backoffice/rekening/page", payload).then(
        ({ data }) => {
          commit("SET_DATAS", data);
          commit("SET_LOADING", false);
        }
      );
    },
    async all({ commit }, payload) {
      commit("SET_LOADING", true);
      return await Api.doPaginate("backoffice/rekening").then(({ data }) => {
        commit("SET_ALL", data);
        commit("SET_LOADING", false);
      });
    },
    closeModalCreate({ commit, state }) {
      commit("SET_MODAL_CREATE", false);
      state.action = "";
    },
    onAction({ commit, state }, payload) {
      if (payload[1] === "Create") {
        commit("SET_MODAL_CREATE", true);
        state.action = "Tambah";
        state.form = {};
      } else if (payload[1] === "Update") {
        state.action = "Update";
        state.form = payload[0];
        commit("SET_MODAL_CREATE", true);
      }
    },
    confirmation({ commit }, payload) {
      confirmations.confirmationForm(payload[0], `rekening/${payload[1]}`);
    },
    onRefresh({ state }) {
      store.dispatch("rekening/paginate", state.queryParam);
    },
    async Tambah({ commit }, payload) {
      commit("SET_LOADING", true);
      return await AuthenticationService.post("backoffice/rekening/", payload)
        .then(({ data }) => {
          commit("SET_LOADING", false);
          alerts.sweetalertToast("success", data.message);
          store.dispatch("rekening/onRefresh");
          commit("SET_MODAL_CREATE", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          store.dispatch("loading/setLoading", false);
          alerts.sweetalertToast("error", error.response.data.message);
        });
    },
    async Update({ commit }, payload) {
      commit("SET_LOADING", true);
      return await AuthenticationService.put(
        "backoffice/rekening/" + payload.rekening_bank_id,
        payload
      )
        .then(({ data }) => {
          commit("SET_LOADING", false);
          alerts.sweetalertToast("success", data.message);
          store.dispatch("rekening/onRefresh");
          commit("SET_MODAL_CREATE", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          store.dispatch("loading/setLoading", false);
          alerts.sweetalertToast("error", error.response.data.message);
        });
    },
  },
};

export default rekening;
